module.exports = __webpack_public_path__ + "static/media/covi_wel_cle_mat.3a271702.png";